"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("components");
function FinancingPartners() {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "page-container", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { className: "text-underline text-center", children: "Financing Partners" }), (0, jsx_runtime_1.jsx)(components_1.P, { className: "mar-t-8", children: "Comenity Capital Bank" }), (0, jsx_runtime_1.jsx)(components_1.P, { className: "mar-t-8", children: "First Bank & Trust serviced by Imprint Payments, Inc" })] }));
}
exports.default = FinancingPartners;
